import { VIVACE_SUBPATH, VIVACE_IFRAME_SUBPATH, XCARD_PPE, XCARD_DOMAIN } from "../constants/LinkConstants.js";
import { DRAFT_SENTENCE_NAME, PRODUCTION_BRANCH_ID, entityToVivaceEntity } from "../constants/maui.constants.js";
import { MAUIEntityPaths } from "../models/MAUI.models.js";
import { redirectToExpUXRoute } from "./VivaceOptIn.utils.js";
import { TENANT_ID } from "@ane/core/lib/constants/QueryString.constants";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { appendWPSFlagIfNeeded } from "@ane/core/lib/utils/WPSUtils";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import { ScorecardRouteUtils } from "./ScorecardRoute.utils.js";
import { WindowLocation } from "@ane/core/lib/services/WindowService";
import parseURL from "url-parse";
import { matchPath } from "react-router";
import { FeatureProgressionRouteUtils } from "./FeatureProgressionRoute.utils.js";
import { FeatureExperimentRouteUtils } from "./FeatureExperimentRoute.utils.js";
import { ROUTES } from "./Routes.constants.js";
const convertWorkspaceIdToOldLink = (workspaceId) => {
  return VIVACE_SUBPATH.replace(/\/+$/, "") + `/#!/workspace/${workspaceId}`;
};
const getVivaceLink = (workspaceId) => {
  if (redirectToExpUXRoute()) {
    return `${VIVACE_IFRAME_SUBPATH}?workspaceId=${workspaceId}`;
  }
  return convertWorkspaceIdToOldLink(workspaceId);
};
const getVivaceAnalysisTemplateLink = (workspaceId, metricSetName, analysisTemplateName, metricSetVersion) => {
  let link = redirectToExpUXRoute() ? `${VIVACE_IFRAME_SUBPATH}` : convertWorkspaceIdToOldLink(workspaceId);
  if (!metricSetName) {
    return link;
  } else if (!analysisTemplateName) {
    link += redirectToExpUXRoute() ? `/${metricSetName}/${DRAFT_SENTENCE_NAME}/${PRODUCTION_BRANCH_ID}/${MAUIEntityPaths["analysis-template"]}?workspaceId=${workspaceId}` : `/metric-set/${metricSetName}/${DRAFT_SENTENCE_NAME}/${PRODUCTION_BRANCH_ID}/${entityToVivaceEntity["analysis-template"]}`;
  } else if (!metricSetVersion) {
    link += redirectToExpUXRoute() ? `/${metricSetName}/${DRAFT_SENTENCE_NAME}/${PRODUCTION_BRANCH_ID}/${MAUIEntityPaths["analysis-template"]}/${analysisTemplateName}/edit?workspaceId=${workspaceId}` : `/metric-set/${metricSetName}/${DRAFT_SENTENCE_NAME}/${PRODUCTION_BRANCH_ID}/${entityToVivaceEntity["analysis-template"]}/UserDefinedFiles%5cAnalysisTemplates%5c${analysisTemplateName}.json`;
  } else {
    link += redirectToExpUXRoute() ? `/${metricSetName}/${DRAFT_SENTENCE_NAME}/${metricSetVersion}/${MAUIEntityPaths["analysis-template"]}/${analysisTemplateName}/edit?workspaceId=${workspaceId}` : `/metric-set/${metricSetName}/${DRAFT_SENTENCE_NAME}/${metricSetVersion}/${entityToVivaceEntity["analysis-template"]}/UserDefinedFiles%5cAnalysisTemplates%5c${analysisTemplateName}.json`;
  }
  link = appendWPSFlagIfNeeded(link);
  link = NavigationService.getCustomQueryParams(link);
  return link;
};
const getVivaceMetricSetLink = (workspaceId, metricSetName) => {
  let link = redirectToExpUXRoute() ? `${VIVACE_IFRAME_SUBPATH}/${metricSetName}/${DRAFT_SENTENCE_NAME}/${PRODUCTION_BRANCH_ID}/${MAUIEntityPaths.metric}` : `${convertWorkspaceIdToOldLink(workspaceId)}/metric-set/${metricSetName}/${DRAFT_SENTENCE_NAME}/${PRODUCTION_BRANCH_ID}/${entityToVivaceEntity.metric}`;
  link = appendWPSFlagIfNeeded(link);
  link = NavigationService.getCustomQueryParams(link);
  return link;
};
const getScorecardLink = (scorecardId, stepId) => {
  let hostName = EnvironmentService.usePreProd() ? XCARD_PPE : XCARD_DOMAIN;
  const scorecardQueryParams = `?stepid=${stepId}&scorecardids=${scorecardId}`;
  hostName = NavigationService.getCustomQueryParams(
    `${WindowLocation.origin}${ScorecardRouteUtils.routes.root.url()}${scorecardQueryParams}`
  );
  const xcardLink = hostName;
  return getXcardLinkWithQueryParams(xcardLink);
};
const getXcardLinkWithQueryParams = (originUrl) => {
  var _a;
  let url = appendTIDIfNeeded(originUrl);
  const path = !!((_a = url.match(new RegExp(/\/xcard\//i))) == null ? void 0 : _a.length) ? url.replace(/\/xcard\//i, ScorecardRouteUtils.routes.root.url()) : url;
  url = NavigationService.getCustomQueryParams(path, WindowLocation.search);
  return url;
};
const appendTIDIfNeeded = (originUrl) => {
  const tid = NavigationService.getUrlParam(TENANT_ID);
  if (EnvironmentService.wsplitDeprecateUsingTid()) {
    return originUrl;
  } else {
    return originUrl + NavigationService.addParamToQuery({ url: originUrl, param: TENANT_ID, value: tid });
  }
};
const addHostnameToScorecardLink = (scorecardLink) => {
  var _a;
  const hostName = (EnvironmentService.usePreProd() ? XCARD_PPE : XCARD_DOMAIN).replace(/\/xcard\//i, "");
  let xcardLink = hostName + scorecardLink;
  const path = `${WindowLocation.origin}${!!((_a = scorecardLink.match(new RegExp(/\/xcard\//i))) == null ? void 0 : _a.length) ? scorecardLink.replace(/\/xcard\//i, ScorecardRouteUtils.routes.root.url()) : `${ScorecardRouteUtils.routes.root.url()}${scorecardLink}`}`;
  xcardLink = NavigationService.getCustomQueryParams(path, WindowLocation.search);
  return getXcardLinkWithQueryParams(xcardLink);
};
const getProgressionPath = (experimentSummaryPlanInfo) => {
  let path = experimentSummaryPlanInfo ? experimentSummaryPlanInfo.FeatureProgressionHighlightUrl : "";
  if (EnvironmentService.isUnifiedView) {
    var { pathname } = parseURL(path || "");
    var match = matchPath(pathname, {
      path: `${ROUTES.studio.match.path}${FeatureExperimentRouteUtils.routes.audienceStageView.path()}`,
      exact: true,
      strict: true
    });
    if (!!match) {
      const { params } = match;
      const { featureId, audienceStageId } = params;
      path = FeatureProgressionRouteUtils.routes.progressionStageView.getURL(featureId, [audienceStageId]);
    }
  }
  return path || "";
};
export {
  addHostnameToScorecardLink,
  appendTIDIfNeeded,
  getProgressionPath,
  getScorecardLink,
  getVivaceAnalysisTemplateLink,
  getVivaceLink,
  getVivaceMetricSetLink,
  getXcardLinkWithQueryParams
};
//# sourceMappingURL=ExternalRoute.utils.js.map
